/*
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-05-18 11:56:52
 * @LastEditors: chen wei
 * @LastEditTime: 2020-07-17 16:57:37
 */
const rqParams = {
  // 获取是否需要弹窗
  getrewardresult(param) {
    return {
      op_path: 'member.qkmember.getrewardresult',
      ...param
    }
  },
  getstudentinfo() {
    return {
      op_path: 'user.userinfo.getstudentinfo'
    }
  },
  getusermemberinfo() {
    return {
      op_path: 'member.qkmember.getusermemberinfo'
    }
  },
  submitreceivereward(param) {
    return {
      op_path: 'member.qkmember.submitreceivereward',
      ...param
    }
  },
  getquestioninfo(param) {
    return {
      op_path: 'exercisebook.book.getquestioninfo',
      ...param
    }
  },
  // 获取要跳转的列表
  getlistenspeakinfov2(param) {
    return {
      op_path: 'exercisebook.book.getlistenspeakinfov2',
      ...param
    }
  },

  getweixinjsapiconfig(param) {
    return {
      op_path: 'information.weixinapi.getweixinjsapiconfig',
      ...param
    }
  },
  getweixinvoicetestinfo(param) {
    return {
      op_path: 'information.weixinapi.getweixinvoicetestinfo',
      ...param
    }
  },
  submitbookstudyrecord(param) {
    return {
      op_path: 'exercisebook.book.submitbookstudyrecord',
      ...param
    }
  },
  getmodelinfo(param) {
    return {
      op_path: 'study.knowledge.getmodelinfo',
      ...param
    }
  }
}
export default rqParams
